var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\t"+_vm._s(_vm.tradable.product.origin)+"\n\t"+_vm._s(_vm.$cropOptions.getLocalizedLabel(
			_vm.tradable.product.grade,
			_vm.$cropOptions.productGradeOptions
		))+", "+_vm._s(_vm.__("Harvest"))+" "+_vm._s(_vm.tradable.product.harvest)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }